module.exports = __webpack_public_path__ + "img/14.ab1e31e9.png";